import React from "react";

// mui components
import { Box, Drawer } from "@mui/material";

// custom components
import RequestLockDrawer from "./components/request-lock";
import ExtendLockDrawer from "./components/extend-lock";
import ConditionTrackingDrawer from "./components/condition-tracking";
import ChangeRequestDrawer from "./components/change-request";
import DocumentsDrawer from "./components/documents";
import DocumentsTrackerDrawer from "./components/documents-tracker";
import AddResourceDrawer from "./components/add-resource";
import RemoveUserDrawer from "./components/remove-user";
import AddUserDrawer from "./components/add-user";
import ViewLinkedLiabilities from "./components/linked-liabilities";
import AddRealEstate from "./components/add-real-estate";
import EligibleProductDrawer from "./components/eligible-product";
import AdjusmentProductDrawer from "./components/adjustments-product-details";
import RequestClosingDateDrawer from "./components/request-closing-date";
import AddMessageDrawer from "./components/add-message";
import UpdateMessageDrawer from "./components/update-message";
import MessageHistoryDrawer from "./components/message-history";
import DocumentTrackerDetailDrawer from "./components/document-tracker-detail";
import EnhancedConditionDetailDrawer from "./components/enhanced-condition-detail";
import GlossaryDrawer from "./components/glossary";

// helper utils
import { MESSAGE_DRAWER_TYPES } from "../../utils/messages.constants";

// custom styles
import styles from "./index.module.scss";

export default function TemporaryDrawer({
	// request-lock props
	loanData,
	fieldData,
	// condition tracking props
	selectedCondition,
	setSelectedCondition,
	// remove user props
	setRedirect,
	// linked liabilities props
	selectedTab,
	liabilitiesData,
	selectedRealEstate,
	selectedRealEstateData,
	// add real estate props
	realEstateData,
	setRealEstateData,
	// eligible products
	drawerData,
	conditionTypeOptions,
	// drawer props
	toggleDrawer,
	drawerOpen,
	drawerDirection,
	drawerType,
	handleCloseDrawer,
	handleOpenProcessingModal,
	handleCloseProcessingModal,
	setProcessingText,
	handleOpenSuccessModal,
	setSuccessText,
	setDocumentTrackerUploadProgress,
	handleOpenLoadingDataModal,
	handleCloseLoadingDataModal,
	setLoadingDataText,
	isConditionStatusLoaded,
	handleOpenErrorModal,
	setErrorText,
	setErrorTitle,
	handleOpenCommonErrorModal,
	refreshMessages,
}) {
	let drawerContent = null;

	if (drawerType === "request-lock") {
		drawerContent = (
			<RequestLockDrawer
				loanData={loanData}
				fieldData={fieldData}
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				// error
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
			/>
		);
	} else if (drawerType === "extend-lock") {
		drawerContent = (
			<ExtendLockDrawer
				loanData={loanData}
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				// processing
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				// success
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				// error
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
			/>
		);
	} else if (drawerType === "condition-tracking") {
		drawerContent = (
			<ConditionTrackingDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				handleOpenLoadingDataModal={handleOpenLoadingDataModal}
				handleCloseLoadingDataModal={handleCloseLoadingDataModal}
				setLoadingDataText={setLoadingDataText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				// custom props
				selectedCondition={selectedCondition}
				setSelectedCondition={setSelectedCondition}
			/>
		);
	} else if (drawerType === "change-request") {
		drawerContent = (
			<ChangeRequestDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				// error
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
			/>
		);
	} else if (drawerType === "upload-documents") {
		drawerContent = (
			<DocumentsDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
			/>
		);
	} else if (drawerType === "upload-condition-tracker-documents") {
		drawerContent = (
			<DocumentsTrackerDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				setDocumentTrackerUploadProgress={setDocumentTrackerUploadProgress}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				// custom props
				drawerData={drawerData}
			/>
		);
	} else if (drawerType === "add-resource") {
		drawerContent = (
			<AddResourceDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
			/>
		);
	} else if (drawerType === "remove-user") {
		drawerContent = (
			<RemoveUserDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
				// custom props
				setRedirect={setRedirect}
			/>
		);
	} else if (drawerType === "add-user") {
		drawerContent = (
			<AddUserDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				// custom props
				setRedirect={setRedirect}
			/>
		);
	} else if (drawerType === "linked-liabilities") {
		drawerContent = (
			<ViewLinkedLiabilities
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				// custom props
				selectedTab={selectedTab}
				liabilitiesData={liabilitiesData}
				selectedRealEstate={selectedRealEstate}
				selectedRealEstateData={selectedRealEstateData}
			/>
		);
	} else if (drawerType === "add-real-estate") {
		drawerContent = (
			<AddRealEstate
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				// custom props
				selectedTab={selectedTab}
				selectedRealEstateData={selectedRealEstateData}
				realEstateData={realEstateData}
				setRealEstateData={setRealEstateData}
			/>
		);
	} else if (drawerType === "eligible-product") {
		drawerContent = (
			<EligibleProductDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
				// custom props
				drawerData={drawerData}
			/>
		);
	} else if (drawerType === "quick-pricer-adjusments-detail") {
		drawerContent = (
			<AdjusmentProductDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
				// custom props
				drawerData={drawerData}
			/>
		);
	} else if (drawerType === "request-closing-date") {
		drawerContent = (
			<RequestClosingDateDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				// error
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
			/>
		);
	} else if (drawerType === MESSAGE_DRAWER_TYPES.ADD_MESSAGE) {
		drawerContent = (
			<AddMessageDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				drawerData={drawerData}
				drawerType={drawerType}
				toggleDrawer={toggleDrawer}
				// error
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				refreshMessages={refreshMessages}
			/>
		);
	} else if (drawerType === MESSAGE_DRAWER_TYPES.EDIT_MESSAGE) {
		drawerContent = (
			<UpdateMessageDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				drawerData={drawerData}
				drawerType={drawerType}
				toggleDrawer={toggleDrawer}
				// error
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				refreshMessages={refreshMessages}
			/>
		);
	} else if (drawerType === MESSAGE_DRAWER_TYPES.MESSAGE_HISTORY) {
		drawerContent = (
			<MessageHistoryDrawer
				// default drawer props
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				drawerData={drawerData}
				drawerType={drawerType}
				toggleDrawer={toggleDrawer}
				// error
				handleOpenErrorModal={handleOpenErrorModal}
				setErrorText={setErrorText}
				refreshMessages={refreshMessages}
			/>
		);
	} else if (drawerType === "document-tracker-detail") {
		drawerContent = (
			<DocumentTrackerDetailDrawer
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				isConditionStatusLoaded={isConditionStatusLoaded}
				conditionTypeOptions={conditionTypeOptions}
				drawerData={drawerData}
			/>
		);
	} else if (drawerType === "enhanced-condition-detail") {
		drawerContent = (
			<EnhancedConditionDetailDrawer
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setProcessingText={setProcessingText}
				setSuccessText={setSuccessText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				drawerData={drawerData}
			/>
		);
	} else if (drawerType === "glossary") {
		drawerContent = (
			<GlossaryDrawer
				handleCloseDrawer={handleCloseDrawer}
				drawerData={drawerData}
			/>
		);
	}

	return (
		<Drawer
			anchor={drawerDirection}
			open={drawerOpen[drawerDirection]}
			onClose={handleCloseDrawer}
			className={styles.drawerContainer}
		>
			<Box
				role="presentation"
				className={`${styles.drawerMainDiv} ${
					drawerType === "glossary" ? styles.glossaryDrawerMainDiv : ""
				}`}
			>
				{drawerContent}
			</Box>
		</Drawer>
	);
}
